<template>
  <v-dialog v-model="dialog" persistent max-width="950px" ref="winAssociation">
    <v-card>
      <v-card-title>
        <div>
          <h1>
            Importer
            <span class="bis">Les traductions</span>
          </h1>
        </div>
      </v-card-title>
      <v-card-text grid-list-xl :style="stylecontainer">
        <v-container fluid pa-0 grid-list-xl formlittle ref="mycontainer">
          <v-form ref="form" v-model="valid">
            <p>Vous devez utiliser le fichier de traductions que vous avez précédemment exporté.</p>
            <m-form-file
              label="Fichier de traductions"
              ref="inputTrads"
              @inputfile="hasFileMatrice"
            />
          </v-form>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary2" text @click="cancelWin()" :disabled="disabledBtn">Annuler</v-btn>
        <v-btn color="primary2" depressed :disabled="disabledBtn" @click="saveWin()">Importer</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "matricewintrads",
  props: ["ca_id"],
  data() {
    return {
      stylecontainer: ``,
      disabledBtn: false,
      dialog: false,
      valid: true,
      matrice: null,
      showNormeMatrice: false
    };
  },
  mounted() {
    window.addEventListener("resize", this.setContainerStyle);
  },
  destroyed() {
    window.removeEventListener("resize", this.setContainerStyle);
  },
  computed: {},
  watch: {
    showNormeMatrice() {
      this.setContainerStyle(true);
    }
  },
  components: {},
  methods: {
    open() {
      this.dialog = true;
      this.disabledBtn = false;
      this.setContainerStyle();
      //if (this.$refs.inputMatrice) this.$refs.inputMatrice.reset();
    },
    hasFileMatrice(files) {
      // console.log("files", files);
      if (files.length) this.matrice = files[0];
    },
    cancelWin() {
      this.dialog = false;
    },
    async saveWin() {
      this.disabledBtn = true;
      if (this.matrice) {
        let formData = new FormData();
        formData.append("ca_id", this.ca_id);
        formData.append("file", this.matrice);
        await this.$axios.post(
          this.$config.server_url + "/api/1.0/matrice/tradsimport",
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data"
            }
          }
        );
      }
      this.$emit("getMatrice");
      this.dialog = false;
    },
    setContainerStyle(bis = false) {
      this.$nextTick(() => {
        if (!this.$refs.mycontainer) return;
        if (this.$refs.mycontainer.clientHeight > window.innerHeight - 300)
          this.stylecontainer = `height: calc(100vh - 253px); overflow:auto;`;
        else this.stylecontainer = "";
      });
      if (bis) {
        setTimeout(() => {
          this.setContainerStyle();
        }, 500);
      }
    }
  }
};
</script>

<style lang="scss">
.btn-norme-matrice {
  width: 100%;
}
</style>